export default function filterText() {
  return {
    filter: '',

    filtered(str) {
      return (str || '').toLowerCase().includes(this.filter.toLowerCase());
    },
  };
}
